import { useState } from "react";
import { TextField, Button, Typography, Alert, Snackbar, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../images/Logo.png";
import axiosInstance from "../../../utils/axiosInstance";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setOpen(true);
    setLoading(true);

    if (!email || !password) {
      setMessage("Failure! Email and password are required.");
      setLoading(false);
      return;
    }

    await axiosInstance
      .post(`auth/login`, { email, password })
      .then((response) => {
        setMessage("Success! logged in successfully");
        const user = {
          user_id: response.data.user_id
        }
        localStorage.setItem("gym_user", JSON.stringify(user));
        setTimeout(() => {
          setOpen(false);
          setLoading(false)
          navigate("/account");
        }, 2000);
      })
      .catch((err) => {
        if (err.response) {
          setMessage("Failure! Invalid credentials");
          setTimeout(() => {
            setOpen(false);
            setLoading(false)
          }, 2000);
        } else {
          setMessage("Failure! Something went wrong, please try again.");
          setTimeout(() => {
            setOpen(false);
            setLoading(false)
          }, 2000);
        }
      });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full">
        <div className="w-full mb-4 flex justify-center items-center">
          <Link to="/">
            <img src={Logo} alt="logo" className="w-20 h-20 mx-auto" />
          </Link>
        </div>
        <Typography variant="h4" component="h1" className="mb-4 text-center text-blue-950">
          Login
        </Typography>
        <form onSubmit={handleLogin} className="mt-8">
          <div className="mb-4">
            <TextField label="Email" type="email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} required variant="outlined" />
          </div>
          <div className="mb-2">
            <TextField label="Password" type={showPassword ? "text" : "password"} fullWidth value={password} onChange={(e) => setPassword(e.target.value)} required variant="outlined" InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            />
          </div>

          {/* forgot passworod */}
          <div className="mb-4 text-right">
            <Link to="/auth/forgotpassword" className="text-blue-500 hover:text-blue-700">
              Forgot Password?
            </Link>
          </div>
          {loading ?
            <Button variant="contained" color="primary" fullWidth disabled className="py-2">
              Loading...
            </Button>
            :
            <Button type="submit" variant="contained" color="primary" fullWidth className="py-2">
              Login
            </Button>
          }
        </form>
      </div>

      <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert color={message.startsWith("Success") ? "success" : message.startsWith("Failure") ? "error" : "warning"}>{message}</Alert>
      </Snackbar>
    </div>
  );
};

export default LoginPage;
